import { MenuState, useMenuState } from '@szhsin/react-menu';
import { useCallback, useState } from 'react';
import { IPosition2d } from '../../core/types/ui/position';
import { KonvaEventObject } from 'konva/lib/Node';

interface FilterDropdownState extends IPosition2d {
  colIndex: number;
}

export interface UseFilterDropdown {
  filterMenuState: {
    state?: MenuState;
    endTransition: () => void;
  };
  filterDropdownState: FilterDropdownState;
  openFilterDropdown: (
    e: KonvaEventObject<MouseEvent>,
    colIndex: number
  ) => void;
  closeFilterDropdown: () => void;
}

export default (focusSheet: () => void): UseFilterDropdown => {
  const [filterMenuState, toggleFilterDropdown] = useMenuState({
    unmountOnClose: true,
  });

  const [filterDropdownState, setFilterDropdownState] =
    useState<FilterDropdownState>({
      x: 0,
      y: 0,
      colIndex: -1,
    });

  const openFilterDropdown = useCallback(
    (e: KonvaEventObject<MouseEvent>, colIndex: number) => {
      const evt = e.evt;
      evt?.preventDefault();

      setFilterDropdownState({
        x: evt.clientX,
        y: evt.clientY,
        colIndex,
      });

      toggleFilterDropdown(true);
    },
    [toggleFilterDropdown]
  );

  const closeFilterDropdown = useCallback(() => {
    toggleFilterDropdown(false);
    focusSheet();
  }, []);

  return {
    filterMenuState,
    filterDropdownState,
    openFilterDropdown,
    closeFilterDropdown,
  };
};
